import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EasyClaimAppState } from 'src/easyclaim.api.client.typescript/src';

import { AppState } from '../AppState';

import OdometerAndMileageControl from './Controls/OdometerAndMileageControl';
import { ScreenComponent } from './ScreenComponent';

export class DashboardMileage extends ScreenComponent<AppState, {}> {
	public render() {
		return (
			<div className="main-container">
				<h2 className="dashboard-mileage-title">
					<FormattedMessage id="dashboardMileage.headline.first" />
				</h2>
				<OdometerAndMileageControl
					appState={this.props}
					screen={EasyClaimAppState.DashboardMileage}
					odometerTextInputType={'Default'}
					enableMotorbikesSupport={
						this.props.easyClaimCase?._configuration?.enableMotorbikesSupport ?? false
					}
				/>
			</div>
		);
	}
}
